import React from 'react';
import { motion } from 'framer-motion';

export default function SuccessView({ onReset }) {
  return (
    <motion.div 
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      className="flex flex-col items-center justify-center py-8 text-center"
    >
      <motion.div 
        initial={{ rotate: -15, scale: 0 }}
        animate={{ rotate: 0, scale: 1 }}
        transition={{ type: "spring", stiffness: 200, damping: 10, delay: 0.1 }}
        className="text-6xl mb-4"
      >
        🎉
      </motion.div>
      <h2 className="text-2xl font-bold mb-2">申告完了！</h2>
      <p className="text-brand-accent text-xl font-bold mb-8">+10pt 獲得しました</p>
      
      <button
        onClick={onReset}
        className="w-full py-3 px-4 bg-transparent border-2 border-brand-main text-brand-main font-bold rounded-xl hover:bg-brand-main hover:text-white transition-colors duration-200"
      >
        もう一度申告する
      </button>
    </motion.div>
  );
}